export const getNotFoundRecoveryAction = (
  historyLength: number
): 'back' | 'home' => {
  return historyLength > 1 ? 'back' : 'home';
};
